/*
 * Cart item removal popup (sections/cart-remove-popup.liquid).
 *
 * Cart remove buttons (<remove-item><a data-ajax-cart-request-button ...>) are
 * handled by Liquid Ajax Cart (m-cart.js) via a bubble-phase click listener on
 * document. This adds a CAPTURE-phase listener on document, which always runs
 * first, stops the original handler and opens the popup instead. On confirm,
 * the same cart/change request is replayed through window.liquidAjaxCart.change()
 * so the drawer / cart page re-render exactly as before.
 *
 * The dialog is looked up at click time, so when the popup is disabled (the
 * section renders nothing) or re-rendered in the theme editor, clicks simply
 * pass through / keep working.
 */
(function () {
    'use strict';
    if (window.__cartRemovePopupBound) return;
    window.__cartRemovePopupBound = true;

    var pendingTrigger = null;

    function getDialog() {
        return document.getElementById('cartRemovePopup');
    }

    function openDialog(dialog) {
        if (dialog.open) return;
        if (typeof dialog.showModal === 'function') {
            dialog.showModal();
        } else {
            dialog.setAttribute('open', '');
        }
    }

    function closeDialog(dialog) {
        pendingTrigger = null;
        if (!dialog) return;
        if (typeof dialog.close === 'function') {
            if (dialog.open) dialog.close();
        } else {
            dialog.removeAttribute('open');
        }
    }

    function removeItem(trigger) {
        var url;
        try {
            url = new URL(trigger.getAttribute('href'), window.location.origin);
        } catch (err) {
            return;
        }
        if (window.liquidAjaxCart && typeof window.liquidAjaxCart.change === 'function') {
            var formData = new FormData();
            url.searchParams.forEach(function (value, key) {
                formData.append(key, value);
            });
            window.liquidAjaxCart.change(formData, { info: { initiator: trigger } });
        } else {
            window.location.href = url.toString();
        }
    }

    document.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var dialog = getDialog();
        if (!dialog) return; // popup disabled -> normal removal

        // Buttons inside the popup
        if (target.closest('[data-cart-remove-popup-accept]')) {
            var trigger = pendingTrigger;
            closeDialog(dialog);
            if (trigger) removeItem(trigger);
            return;
        }
        if (target.closest('[data-cart-remove-popup-cancel]')) {
            closeDialog(dialog);
            return;
        }
        // Click on the backdrop (outside the popup box) cancels
        if (target === dialog) {
            closeDialog(dialog);
            return;
        }

        // Cart remove button
        var removeTrigger = target.closest('remove-item [data-ajax-cart-request-button]');
        if (!removeTrigger) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        pendingTrigger = removeTrigger;
        openDialog(dialog);
    }, true);

    // Escape key closes natively; clear the pending removal
    document.addEventListener('close', function (event) {
        if (event.target && event.target.id === 'cartRemovePopup') pendingTrigger = null;
    }, true);

    // Theme editor: preview the popup while its section is selected
    if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', function (event) {
            var dialog = getDialog();
            if (dialog && dialog.dataset.sectionId === event.detail.sectionId) openDialog(dialog);
        });
        document.addEventListener('shopify:section:deselect', function (event) {
            var dialog = getDialog();
            if (dialog && dialog.dataset.sectionId === event.detail.sectionId) closeDialog(dialog);
        });
        document.addEventListener('shopify:section:load', function (event) {
            var dialog = getDialog();
            if (dialog && dialog.dataset.sectionId === event.detail.sectionId) openDialog(dialog);
        });
    }
})();
